import cn from 'classnames';
import style from './sendReceipt.module.scss';
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import { ReactComponent as CrossIcon } from '@assets/images/receiptCancel.svg';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const SendReceipt = props => {
  const { filteredCheck, currency, onClose, receiptStatus } = props;
  const [selectedTickets, setSelectedTickets] = useState(new Map());
  const { handleReceipt } = useOutletContext();

  useEffect(() => {
    if (Object.keys(receiptStatus).length > 0) {
      setSelectedTickets(new Map());
    }
  }, [receiptStatus]);

  const handleSelectTickets = ticket => {
    const updatedTickets = new Map(selectedTickets);
    if (updatedTickets.has(ticket.id)) {
      updatedTickets.delete(ticket.id);
    } else {
      updatedTickets.set(ticket.id, ticket);
    }
    setSelectedTickets(updatedTickets);
  };
  const handleSelectAllTickets = () => {
    const allSelected = filteredCheck?.tickets?.every(ticket =>
      selectedTickets.has(ticket.id)
    );
    const newSelectedTickets = new Map();

    if (!allSelected) {
      filteredCheck.tickets.forEach(ticket =>
        newSelectedTickets.set(ticket.id, ticket)
      );
    }
    setSelectedTickets(newSelectedTickets);
  };

  const onReceiptAction = type => {
    const ticketsArray = Array.from(selectedTickets.values()).map(
      ticket => ticket.ticketId
    );
    const memberId = Array.from(selectedTickets.values())[0]?.memberId;
    handleReceipt(type, ticketsArray, memberId);
  };

  return (
    <div className="w-100 h-100 position-relative">
      <div className="fs-16 fw-600">{FLABEL().RECEIPT}</div>
      <div className={cn(style.receiptTableConatiner)}>
        <Header
          handleSelectAllTickets={handleSelectAllTickets}
          selectedTickets={selectedTickets}
          filteredCheck={filteredCheck}
        />
        <div className={cn('w-100 overflowY', style.tbodyWrapper)}>
          {filteredCheck?.tickets?.length > 0 ? (
            filteredCheck?.tickets?.map((ticket, index) => (
              <div
                className={cn(
                  style.contentTxt,
                  (index & 1) === 0
                    ? `${style.evenIndexTabBg}`
                    : `${style.oddIndexTabBg}`,
                  style.tBodyContainer
                )}
                key={`ticket-${ticket.id}`}
              >
                <div className={cn(style.headerTiltle, style.flex03, 'pl-2')}>
                  <input
                    checked={selectedTickets.has(ticket.id)}
                    className={style.input}
                    type="checkbox"
                    onClick={() => handleSelectTickets(ticket)}
                  />
                </div>
                <div className={cn(style.headerTiltle, style.flex1)}>
                  {ticket.cardType}
                </div>
                <div className={cn(style.headerTiltle, style.flex1)}>
                  {ticket.redactedCardNumber}
                </div>
                <div className={cn(style.headerTiltle, style.flex1)}>
                  {ticket.cardHolderName}
                </div>
                <div className={cn(style.headerTiltle, style.flex1)}>
                  {currency}
                  {ticket.ticketAmount?.toFixed(2)}
                </div>
                <div className={cn(style.headerTiltle, style.flex1)}>
                  {currency}
                  {ticket.tipAmount?.toFixed(2)}
                </div>
                <div className={cn(style.headerTiltle, style.flex1)}>
                  {ticket.ticketTypeId === 1
                    ? FLABEL().RECEIPT_PAYMENT
                    : FLABEL().RECEIPT_REFUND}
                </div>
                <div className={cn(style.headerTiltle, style.flex1)}>
                  {Object.keys(receiptStatus).length !== 0 ? (
                    receiptStatus[ticket.ticketId] ? (
                      receiptStatus[ticket.ticketId]?.succeded ? (
                        <SuccessIcon className={style.receiptStatusIcon} />
                      ) : (
                        <CrossIcon className={style.receiptStatusIcon} />
                      )
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className='h-100 align-items-center col-12 d-flex justify-content-center'>{FLABEL().NO_ITEMS_FOUND}</div>
          )}
        </div>
      </div>
      <div
        className={cn(
          'w-100 d-flex justify-content-center align-items-center position-absolute',
          style.btnContainer
        )}
      >
        <button
          onClick={() => onClose('close')}
          className={cn(style.cancelBtn)}
        >
          {FLABEL().RECEIPT_CANCEL}
        </button>
        <button
          disabled={selectedTickets.size === 0}
          className={cn(style.receiptBtn)}
          onClick={() => onReceiptAction(FLABEL().PRINT)}
        >
          {FLABEL().RECEIPT_PRINT}
        </button>
        <button
          disabled={selectedTickets.size === 0}
          className={cn(style.receiptBtn)}
          onClick={() => onReceiptAction(FLABEL().EMAIL)}
        >
          {FLABEL().RECEIPT_EMAIL}
        </button>
        <button
          disabled={selectedTickets.size === 0}
          className={cn(style.receiptBtn)}
          onClick={() => onReceiptAction(FLABEL().SMS)}
        >
          {FLABEL().RECEIPT_TEXT}
        </button>
      </div>
    </div>
  );
};

export default SendReceipt;

const Header = ({ handleSelectAllTickets, selectedTickets, filteredCheck }) => {
  return (
    <div className={cn('text-center', style.contentTxt, style.headerContainer)}>
      <div className={cn(style.headerTiltle, style.flex03, 'pl-2')}>
        {filteredCheck?.tickets?.length > 0 && (
          <input
            checked={filteredCheck?.tickets?.length > 0 && filteredCheck?.tickets?.every(ticket =>
              selectedTickets.has(ticket.id)
            )}
            className={style.input}
            type="checkbox"
            onClick={() => handleSelectAllTickets()}
          />
        )}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>{FLABEL().RECEIPT_TYPE}</div>
      <div className={cn(style.headerTiltle, style.flex1)}>{FLABEL().RECEIPT_CARD}</div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().RECEIPT_NAME}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().RECEIPT_TOTAL}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>{FLABEL().RECEIPT_TIP}</div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().RECEIPT_PAYMENT}
        <br />
        {FLABEL().RECEIPT_REFUND}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().RECEIPT_STATUS}
      </div>
    </div>
  );
};
